import comprehensiveIncomeTax from './view/comprehensiveIncomeTax.html'

export default {
  base: {
    state: 'declaration.personalIncomeTax.comprehensiveIncomeTax',
    config: {
      url: '/comprehensiveIncomeTax',
      abstract: true,
      template: '<div ui-view></div>',
      default: 'declaration.personalIncomeTax.comprehensiveIncomeTax.list',
      title: '综合所得税申报',
    },
  },
  list: {
    state: 'declaration.personalIncomeTax.comprehensiveIncomeTax.list',
    config: {
      url: '/list',
      template: comprehensiveIncomeTax,
      controller: 'comprehensiveIncomeTaxCtrl',
    },
  },
}



// WEBPACK FOOTER //
// ./src/app/declaration/personalIncomeTax/comprehensiveIncomeTax/routers.js